import { useState, useEffect, useCallback } from 'react';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function useAdminSecurity() {
  const [dashboardData, setDashboardData] = useState(null);
  const [adminRole, setAdminRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);

  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem('auth_token');
    return { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
  }, []);

  const fetchAdminRole = useCallback(async () => {
    try {
      const r = await fetch(`${BACKEND_URL}/api/admin/me`, { headers: getAuthHeaders() });
      if (r.ok) setAdminRole((await r.json()).role);
    } catch (err) { logger.error('Error fetching admin role:', err); }
  }, [getAuthHeaders]);

  const fetchDashboardData = useCallback(async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/security/dashboard`, { headers: getAuthHeaders() });
      if (response.ok) {
        setDashboardData(await response.json());
        setLastUpdated(new Date());
        setError('');
      } else if (response.status === 403) {
        setError('Access denied. Owner role required to view security dashboard.');
      } else {
        setError('Failed to load security dashboard.');
      }
    } catch (err) {
      logger.error('Error fetching dashboard:', err);
      setError('Failed to connect to security dashboard.');
    } finally {
      setLoading(false);
    }
  }, [getAuthHeaders]);

  useEffect(() => {
    fetchAdminRole();
    fetchDashboardData();
    const interval = setInterval(fetchDashboardData, 30000);
    return () => clearInterval(interval);
  }, [fetchDashboardData, fetchAdminRole]);

  const formatTimestamp = (timestamp) => new Date(timestamp).toLocaleString();

  return { dashboardData, adminRole, loading, error, lastUpdated, fetchDashboardData, formatTimestamp };
}
